import { AjvError } from "@rjsf/core";

const findVal = (object: any, key: string): string | undefined => {
    var value;
    Object.keys(object).some((k: any) => {
        if (k === key) {
            value = object[k];
            return true;
        }
        if (object[k] && typeof object[k] === "object") {
            value = findVal(object[k], key);
            return value !== undefined;
        }
        return false;
    });
    return value;
};


export const uiSchemaToStaticErrors = (uiSchema: { [key: string]: any }): AjvError[] => {
    let errors: AjvError[] = [];

    errors = Object.keys(uiSchema).reduce((acc, key) => {
        const data = uiSchema[key];
        if (typeof data === "object") {
            const staticError = findVal(data, "_StaticValidationError");
            if (staticError) {
                const error: AjvError = {
                    message: staticError,
                    name: "staticError",
                    params: { missingProperty: key },
                    property: `.${key}`,
                    stack: `.${key} ${staticError}`
                };
                return [...acc, error];
            }
        }
        return acc;
    }, errors);

    return errors;
};